import { Box, useRadio, UseRadioProps } from "@chakra-ui/react";

export default function RadioCard({
  ...props
}: UseRadioProps & { children: React.ReactNode }) {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label" w="100%">
      <input {...input} />
      <Box
        {...checkbox}
        h="40px"
        cursor="pointer"
        borderWidth="1px"
        borderRadius="6px"
        _checked={{
          bg: "gray.100",
          color: "white",
          borderColor: "gray.100",
        }}
        _focus={{
          boxShadow: "outline",
        }}
        px="16px"
        py="0px"
        w="100%"
        display="flex"
        alignItems="center"
      >
        <p
          style={{
            fontWeight: 600,
            fontSize: "18px",
            color: "#1A202C",
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          {props.children}
        </p>
      </Box>
    </Box>
  );
}
